module.exports = __webpack_public_path__ + "img/img_zhidunshen.5e39ae5e.png";